import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "toggle-on",
  "use": "toggle-on-usage",
  "viewBox": "0 0 512 448",
  "content": "<symbol viewBox=\"0 0 512 448\" id=\"toggle-on\"><path d=\"M0 224C0 135.75 71.75 64 160 64h192c88.25 0 160 71.75 160 160s-71.75 160-160 160H160C71.75 384 0 312.25 0 224zm352 128c70.5 0 128-57.5 128-128S422.5 96 352 96s-128 57.5-128 128 57.5 128 128 128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/toggle-on.svg
// module id = kcqm
// module chunks = 1